import { TimeOption } from "model/Datatypes";
import { v4 as uuid } from "uuid";
import moment from "moment";

export const hourTimeOption: TimeOption = {
  id: uuid(),
  display: "Previous hour",
  from: moment().subtract(1, "hours").valueOf(),
  to: moment().valueOf(),
  groupingsType: "MINUTES",
};
export const dayTimeOption: TimeOption = {
  id: uuid(),
  display: "Previous day",
  from: moment().subtract(1, "days").valueOf(),
  to: moment().valueOf(),
  groupingsType: "MINUTES",
};
export const weekTimeOption: TimeOption = {
  id: uuid(),
  display: "Previous week",
  from: moment().subtract(7, "days").valueOf(),
  to: moment().valueOf(),
  groupingsType: "HOURS",
};

export const monthTimeOption: TimeOption = {
  id: uuid(),
  display: "Previous month",
  from: moment().subtract(1, "month").valueOf(),
  to: moment().valueOf(),
  groupingsType: "DAYS",
};

export const yearTimeOption: TimeOption = {
  id: uuid(),
  display: "Previous year",
  from: moment().subtract(1, "years").valueOf(),
  to: moment().valueOf(),
  groupingsType: "MONTHS",
};

export const limitedYarTimeOption: TimeOption = {
  id: uuid(),
  display: "Previous year",
  from: moment().subtract(6, "months").valueOf(),
  to: moment().valueOf(),
  groupingsType: "DAYS",
};

export const allTimeOption: TimeOption = {
  id: uuid(),
  display: "All time",
  from: moment().subtract(10, "years").valueOf(),
  to: moment().valueOf(),
  groupingsType: "YEARS",
};

export const stdTimeOptions: TimeOption[] = [
  hourTimeOption,
  dayTimeOption,
  weekTimeOption,
  monthTimeOption,
];
